import React, { Component, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import allApplicationDropdown from '../../dependencies/utils/json/allApplicationDropdown.json'
import { connect } from 'react-redux';
import columns, { rowStyle2 } from './common/dependencies/startupTableColumns';
import Table from '../common/Table';
import './scss/index.scss';
import ActionModal from './modal';
import popArchiveIcon from '../../assests/images/pop-archive.png';
import popApprovedIcon from '../../assests/images/pop-check.png';
import Download from '../common/Download';
import SectionTitle from '../common/sectionTitle/sectionTitle';
import SearchBox from '../common/Search';
import { SearchByStartupApplicationOptions } from './common/constant';
import InputField from '../common/InputField';
import { getNSAReportList, saveNsaResultData, doDownloadResultList, updateNSAReportList, lastGeneratedReportHistory } from '../../dependencies/services/beneficiary';
import Button from '../common/Button';
import downArrowBtn from '../../assests/images/down-arrow-btn.png';
import downArrowBtnblack from '../../assests/images/down-arrow-btn-black.png';
import deleteIconGif from '../../assests/images/delete-icon.gif';
import { toast } from "react-toastify";
import Refresh from '../common/Refresh';
import { ROLES } from '../../constants/Roles';
import { storage } from '../../dependencies/store/storage';
import Select from 'react-select'
import { uploadFileService } from '../../dependencies/services/uploadFileService';
import NsaFileUploadBtn from '../NsaFileUploadBtn';
import { isLoading } from '../../constants/actionConstants';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';

const NSAResult = (props) => {

  const { getNSAReportList, saveNsaResultData, nsaReportDataState: { data, recordsTotal,status,message }, doDownloadResultList, isLoading, updateNSAReportList, lastGeneratedReportHistory } = props;
  const [sortField, setSortField] = useState('applicationDate');
  const [sortOrder, setSortOrder] = useState('DESC');
  const [sizePerPage, setSizePerPage] = useState(20);

  const [dropDownStatus, setDropDownStatus] = useState('text');
  const [edited, setEdited] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [query, setQuery] = useState({
    nsaTag: true, archived: false, edited: null
  });
  const [searchParams, setSearchParams] = useState({});
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [checkedValue, setCheckedValue] = useState([]);
  const [modalValue, setModalValue] = useState(false);
  const [buttonValue, setButtonValue] = useState('');
  const [bulkValue, setBulkValue] = useState({});
  const [natureOption, SetNatureOption] = useState([]);
  const [actionType, setActionType] = useState('');
  const [newApplication, setNewApplication] = useState(false);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showIncompleteHistory, setShowIncompleteHistory] = useState(false);
  const [exemptionId, setExemptionId] = useState("");
  const [diiptNumber, setDiiptNumber] = useState('');
  const [error, setError] = useState('');
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] = useState(false);
  const [nsaResultView, setNsaResultView] = useState(false);
  const [openSelectDropdown, setOpenSelectDropdown] = useState(false);
  const [openNSAYearDropdown, setOpenNSAYearDropdown] = useState(false);
  const [openSelectFilterDropdown, setOpenSelectFilterDropdown] = useState(false);
  const [openNSAYearFilterDropdown, setOpenNSAYearFilterDropdown] = useState(false);
  const [selectFilter, setSelectFilter] = useState('Select By');
  const [nsaYearFilter, setNsaYearFilter] = useState('NSA Year');
  const [select, setSelect] = useState('Select By');
  const [nsaYear, setNsaYear] = useState('NSA Year');
  const [searchDisable, setSearchDisable] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [nameOfEntity, setNameOfEntity] = useState('');
  const [incorporationNumber, setIncorporationNumber] = useState('');
  const [incorporationDate, setIncorporationDate] = useState('');
  const [certificateNumber, setCertificateNumber] = useState('');
  const [fileUploadMessage, setFileUploadMessage] = useState('');
  const [openDeletemodal, setOpenDeletemodal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [DeleteConfirmationStatus, setDeleteConfirmationStatus] = useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showCustomEditNSA, setShowCustomEditNSA] = useState(false);
  const [statusNsaUpdate, setStatusNsaUpdate] = useState(null);
  const [yearNsaUpdate, setYearNsaUpdate] = useState(null);
  const [nsaUpdate, setNsaUpdate] = useState({ tag: '', dippNumber: '' });
  const [nsaDeleteAction, setNsaDeleteAction] = useState('ALL');
  const [historyData, setHistoryData] = useState({});
  const [openHistory, setOpenHistory] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedStatusNSA, setSelectedStatusNSA] = useState([]);
  const [selectedYearNSA, setSelectedYearNSA] = useState([]);
  const [deleteTagOptions, setDeleteTagOptions] = useState([]);
  const userRole = storage.getUserRole();

  const StatusNSA = [
    { value: 'W', label: 'Winner' },
    { value: 'F', label: 'Finalist' },
  ];

  const yearNSA = [
    { value: '2019', label: '2019' },
    { value: '2020', label: '2020' },
    { value: '2021', label: '2021' },
    { value: '2022', label: '2022' },
    { value: '2023', label: '2023' },
    { value: '2024', label: '2024' },
  ];

  useEffect(() => {
    getTableData();
  }, [sortField, sortOrder, sizePerPage, pageNo, searchParams, query, searchText])

  const getTableData = () => {
    getNSAReportList({
      sortColumn: sortField,
      sortOrder: sortOrder.toUpperCase(),
      pageSize: sizePerPage,
      pageIndex: pageNo,
      query
    });
  }

  const onSelectRows = (selectedRows) => {
    setCheckedValue(selectedRows)
  }

  function openEditModal() {
    setOpenDeletemodal(true);
  }

  const openHistoryModal = async () => {
    let data = await lastGeneratedReportHistory();
    if(data){
      setHistoryData(data);
    }
    setOpenHistory(true);
  }

  const closeHistoryModal = () => {
      setOpenHistory(false);
  }

  const closeConfirmationModal = () => {
    setOpenConfirmation(false);
  }

  function openConfirmationModal() {
      setOpenConfirmation(true);
  }

  const toggleDeleteModal = () => {
    setOpenDeletemodal(false);
    setShowCustomEditNSA(false);
    setNsaDeleteAction('ALL');
    setNsaUpdate({ tag: '', dippNumber: '' });
    setYearNsaUpdate(null);
    setStatusNsaUpdate(null);
  }

  const handleConfirmation = (e) => {
    const isConfirmedDelete = e.target.value === "yes";
    setShowDeleteConfirmation(true);
    setDeleteConfirmationStatus(isConfirmedDelete);
  }

  const handleDeleteNsaRecord = () => {
    if(DeleteConfirmationStatus){
      handleUpdateSubmit();
    }
    closeConfirmationModal();
  }

const updateOptions = (currTags) => {
   const currTagArr = currTags[0]?.split(', ');
   setSelectedStatusNSA([]);
   setSelectedYearNSA([]);
  let updatedYearOptions = [];
  let updatedStatusOptions = [];
    for(let i=0;i<currTagArr.length;i++){
      const [currStatusValue, currYearValue] = currTagArr[i].split("_");
      var statusOptions = StatusNSA.filter((status) => currStatusValue === status.value);                 
      var yearOptions = yearNSA.filter((year)=> currYearValue === year.value);
      updatedYearOptions.push(...yearOptions);
      updatedStatusOptions.push(...statusOptions);
    };

    updatedYearOptions = Array.from(new Set(updatedYearOptions.map((item) => JSON.stringify(item)))).map((item) =>
      JSON.parse(item)
    );
  
    updatedStatusOptions = Array.from(new Set(updatedStatusOptions.map((item) => JSON.stringify(item)))).map((item) =>
      JSON.parse(item)
    );
  setSelectedStatusNSA(updatedStatusOptions);
  setSelectedYearNSA(updatedYearOptions);
} 

const updateTagDeleteOptions = (options) => {
  const currTagArr = options[0]?.split(', ');
  const formattedOptions = currTagArr.map(tag => ({value: tag, label: tag}));
  const optionsWithTags = [{ value: '', label: 'Select a tag...', isDisabled: true }, ...formattedOptions];
  setDeleteTagOptions(optionsWithTags);
}

const handleEditClick = (row) => {
  const updateNsaObj = {...nsaUpdate};
  updateNsaObj.dippNumber = row?.certificateNumber;
  setNsaUpdate(updateNsaObj);
  // updateOptions(row?.resultNsa);
  updateTagDeleteOptions(row?.resultNsa);
  setSelectedRows(row);
  openEditModal(); 
  }

  const onSortChange = async (params) => {
    const { order, dataField } = params;
    const newOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC';
    let sortName = '';
    if (dataField === 'mobileNumber') {
      sortName = 'representative.mobile';
    } else if (dataField === 'referenceNumber') {
      sortName = 'referenceNumber';
    } else if (dataField === 'certificateNumber') {
      sortName = 'startupEntity.recognitionNumber';
    } else if (dataField === 'incorporationNumber') {
      sortName = 'incorporationNumber';
    } else if (dataField === 'nameOfEntity') {
      sortName = 'startupEntity.name';
    } else if (dataField === 'applicationDate') {
      sortName = 'applicationDate';
    } else if (dataField === 'registrationDate') {
      sortName = 'startupEntity.corCreatedDate';
    } else if (dataField === 'emailId') {
      sortName = 'representative.email';
    } else {
      sortName = 'createdDate';
    }
    if (dataField !== '') {
      setSortField(sortName);
      // setSortOrder(order.toUpperCase());
      setSortOrder(newOrder);
    }

  }
  const handleOnPageChange = (params) => {
    const { page } = params;
    setPageNo(page - 1);
  }
  const handleOnSizePerPageChange = (params) => {
    const { sizePerPage } = params;
    setSizePerPage(sizePerPage)
    setPageNo(0);
  }

  useEffect(() => {
    if (data && status) {
      setNameOfEntity(data[0]?.nameOfEntity);
      setIncorporationDate(data[0]?.incorporationDate);
      setIncorporationNumber(data[0]?.incorporationNumber);
      setCertificateNumber(data[0]?.certificateNumber);
    }
  else{
    toast.error(message)
  // setNsaResultView(false)

  }

  }, [data])

  const toggleActionModal = () => {
    setModalValue(!modalValue);
    if (modalValue) {
      setActionType('');
    }
  }

  const actionHandler = (actionType) => {
    setActionType(actionType)
  }
  useEffect(() => {
    if (checkedValue.length === 0 && actionType) {
      setButtonValue('invalid')
      toggleActionModal();
    } else {
      bulkApprove();
    }
  }, [actionType])

  const bulkApprove = () => {
    if (actionType === 'approved') {
      toggleActionModal();
      setButtonValue('approved')
      setBulkValue({
        ids: checkedValue,
        status: 'APPROVE'
      })
    } else if (actionType === 'archived') {
      toggleActionModal();
      setButtonValue('archived')
      setBulkValue({
        ids: checkedValue,
        status: 'ARCHIVE'
      })
    }

  }
  function downloadNSAResultList() {
    if (doDownloadResultList) {
      return doDownloadResultList({
        fetchAllRecords: true,
        sortColumn: sortField,
        sortOrder: sortOrder.toUpperCase(),
        pageSize: sizePerPage,
        pageIndex: pageNo,
        query
      }).then((data) => {
        return data;
      })
    }
  }

  useEffect(() => {
    if (props.getSectorOptions) {
      props.getSectorOptions().then((response) => {
        const { data = [] } = response;
        let options = [];
        if (data && data instanceof Array) {
          options = data.reduce((arr, option) => {
            if (option['industryName'] !== null) {
              var text = `${option['sectionName']} (${option['industryName']})` || "";
            } else {
              var text = `${option['sectionName']}` || "";
            }
            const value = option['id'] || "";
            arr.push({ text, value });
            return arr;
          }, []);
        }
        setSectorOptions(options);
      });
    }

    // getNatureOfList().then((response) => {
    //   const { data, status } = response || {};
    //   if (status) {
    //     let options = [];
    //     if (data && data instanceof Array) {
    //       options = data.reduce((arr, option) => {
    //         const text = option['name'] || "";
    //         const value = option['id'] || "";
    //         arr.push({ text, value });
    //         return arr;
    //       }, []);
    //     }
    //     SetNatureOption(options);
    //   }
    // });

  }, [])

  useEffect(() => {
    if (exemptionId) {
      setShowIncompleteHistory(true)
    }
  }, [exemptionId]);
  const clickOnAction = (id) => {
    if (id) {
      setExemptionId(id)
    }
  }
  useEffect(() => {
    if (selectFilter != 'Select By' && nsaYearFilter != 'NSA Year') {
      setSearchDisable(false)
    }
  }, [nsaYearFilter, selectFilter])

  useEffect(() => {
    if (select != 'Select By' && nsaYear != 'NSA Year') {
      setSaveDisable(false)
    }
  }, [nsaYear, select])

  const handleSearch = () => {
    setSelect('Select By');
    setNsaYear('NSA Year');
    setSaveDisable(true);
    setCertificateNumber('');
    setIncorporationDate('');
    setIncorporationNumber('');
    setNameOfEntity('');
    if (diiptNumber) {
      setError('');
      setQuery(() => {
        query.randomReg = diiptNumber
        delete query['status'];
        delete query['nsaTag'];
        return { ...query, 'searchType': 'CREATED_DATE', }
      });
      setSearchText(searchText);
      setPageNo(0);
      setNsaResultView(true)
    } else {
      setHasInvalidSubmitOccurred(true)
      setError("Please enter Recognition number")
    }
  }
  const handleInput = (e, name) => {
    let value = e.target.value;

    if (name === 'diiptNumber') {
      setDiiptNumber(value);
    }
  }
  const handleOpenSelectDropdown = () => {
    setOpenSelectDropdown(!openSelectDropdown);
  }
  const handleOpenSelectFilterDropdown = () => {
    setOpenSelectFilterDropdown(!openSelectFilterDropdown);
  }

  const handleOpenNSAYearDropdown = () => {
    setOpenNSAYearDropdown(!openNSAYearDropdown);
  }
  const handleOpenNSAYearFilterDropdown = () => {
    setOpenNSAYearFilterDropdown(!openNSAYearFilterDropdown);
  }

  const handleSelectByFilter = (event, value) => {
    setSelectFilter(value);
    setOpenSelectFilterDropdown(false);
  }

  const handleNSAYearFilter = (event, value) => {
    setNsaYearFilter(value); // Set the selected value
    setOpenNSAYearFilterDropdown(false);
  };

  const handleUpdateSubmit = async () => {
    if(!nsaDeleteAction){
      toast.error("Please select a valid Tag");
      return;
    }
    const isAllSelected = nsaDeleteAction === "ALL";

    if (!isAllSelected && nsaUpdate.tag === '') {
      toast.error("Tag selection is required. Please make a selection.");
      return;
    }
    const data = await updateNSAReportList({ query: nsaUpdate, params: nsaDeleteAction});
    if (data.status) {
      getTableData();
      setOpenDeletemodal(false);
      setNsaDeleteAction("ALL");
      setNsaUpdate({ tag: '', dippNumber: '' });
      setYearNsaUpdate(null);
      setStatusNsaUpdate(null);
      toast.success(data?.message);
      setShowCustomEditNSA(false);
    } else {
      toast.error(data?.message)
    }
  }

  const handleSubmit = async () => {
    const data = await saveNsaResultData({ dippNumber: diiptNumber, result: select.charAt(0) + '_' + nsaYear })
    if (data.status) {
      window.location.reload();
    } else {
      toast.error(data.message);

    }
  }

  const handleSearchBySelect = () => {
    setQuery(() => {
      query.startupAdminTag = selectFilter.charAt(0) + '_' + nsaYearFilter;
      delete query['edited'];
      delete query['status'];
      return { ...query }
    });
  }


  const handleNSAYear = (event, value) => {
    setNsaYear(value);
    setOpenNSAYearDropdown(false);
  }
  const handleSelectBy = (event, value) => {
    setSelect(value);
    setOpenSelectDropdown(false);
  }

  function refreshStatupList() {
    window.location.reload();
  }

  const onUploadFile = (file) => {
    isLoading(true);
    const data = new FormData();
    data.append('file', file)
    uploadFileService.uploadFileNsaBtn(data).then((data) => {
      if(data?.status){
        toast.success(
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <ul>
                  {data.message.split("\n").map((line, index) => (
                      <li key={index} className='py-1'>{line}</li>
                  ))}
              </ul>
          </div>
        );
        getTableData();
      } else{
        toast.error(
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <ul>
                  {data.message.split("\n").map((line, index) => (
                      <li key={index} className='py-1'>{line}</li>
                  ))}
              </ul>
          </div>
          );
          isLoading(false)
      }
    }, (error) => {
        toast.error(error)
        isLoading(false)
    });
  }

  const setFileUploadSuccessMessage = (message) => {
    setFileUploadMessage(message)
  }

  const handleUpdateTag = (e) => {
    
    setNsaDeleteAction(e.target.value)
    if(e.target.value == 'CUSTOM') {
      setShowCustomEditNSA(true);
    } else {
      setShowCustomEditNSA(false);
    }
    // console.log(showCustomEditNSA, nsaUpdate.tag, nsaDeleteAction);
    
    // console.log((showCustomEditNSA && nsaUpdate.tag==='' && nsaDeleteAction!=='ALL'));
  }

  const updateTag = (status, year) => {
    if (status && year) {
      setNsaUpdate({...nsaUpdate,
        tag: `${status.value}_${year.value}`,
      });
    }
  };

  const handleYearNsaUpdate = selectedOption => {
    setYearNsaUpdate(selectedOption);
    updateTag(statusNsaUpdate, selectedOption);
  };

  const handleStatusNsaUpdate = selectedOption => {
    setStatusNsaUpdate(selectedOption);
    updateTag(selectedOption, yearNsaUpdate);
  }

  const handleDeleteNsaTagUpdate  = selectedOption => {
    const {value} = selectedOption;
    setNsaUpdate({...nsaUpdate, tag: value});
  }

 const startYear = 2019;
  const currentYear = new Date().getFullYear();

  const nsaYearArray = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => (startYear + index).toString()
  );  
  return (

    <div>
      <SectionTitle>NSA</SectionTitle>
      <div className="startup-app-filter-form-results">
        <div className='row ju results-row'>
          <div className='col-md-5 w-100'>
            {userRole === ROLES.SUPER_ADMIN && <>
              <div className="inner-wrap clearfix">
                <div className="left-filter-wrap">
                  <div className='nsa-results'>
                    {
                      <>
                          <NsaFileUploadBtn
                              onUploadFile={onUploadFile}
                              allowedFiles={[".xlsx", ".xls", ".csv"]}
                              successMessage={fileUploadMessage}
                              setSuccessMessage={setFileUploadSuccessMessage}
                          />
                      </>
                    }
                  </div>
                  <div>
                  <button className='history-btn' onClick={openHistoryModal}>Last Updated</button>
                  </div>
                  {/* <div className={`button-wrap`}>
                    <Button
                      className={`bttn`}
                      type="submit"
                      text="Add Report"
                      onClick={handleSearch}

                    />
                  </div> */}

                </div>
              </div>
            </>}
          </div>
          <div className='col-md-7 w-100'>
            {!nsaResultView && <div className='row mt-0 mb-2 mt-0 justify-content-end ml-0 mr-0'>
              <div className='col-md-4'>
              <div onClick={handleOpenSelectFilterDropdown} className={`download-container bttn dropdown-check dropdown-check-list ${openSelectFilterDropdown ? 'show' : ""}`}>
  {selectFilter}  <img width="15px" src={downArrowBtnblack} className='showicon-black' />
  <img src={downArrowBtn} width="15px" className='showicon-white' />
  <ul>
    <li>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          value={'Finalist'}
          id={`radio-${'Finalist'}`}
          name="selectByFilter"
          onChange={(event) => handleSelectByFilter(event, 'Finalist')}
        />
        <label
          className="form-check-label"
          htmlFor={`radio-${'Finalist'}`}
        >
          Finalist
        </label>
      </div>
    </li>
    <li>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          value={'Winner'}
          id={`radio-${'Winner'}`}
          name="selectByFilter"
          onChange={(event) => handleSelectByFilter(event, 'Winner')}
        />
        <label
          className="form-check-label"
          htmlFor={`radio-${'Winner'}`}
        >
          Winner
        </label>
      </div>
    </li>
  </ul>
</div>

              </div>
              <div className='col-md-4'>
                <div onClick={handleOpenNSAYearFilterDropdown}
                  className={`download-container bttn dropdown-check dropdown-check-list ${openNSAYearFilterDropdown ? 'show' : ""}`}
                >
                  {nsaYearFilter}    <img width="15px" src={downArrowBtnblack} className='showicon-black' />
                  <img src={downArrowBtn} width="15px" className='showicon-white' />
                  <ul>
                    {nsaYearArray?.map((el) => (
                      <li key={el}  > {/* Added key attribute */}
                        <div className="form-check" >
                          <input
                            className="form-check-input"
                            type="radio"
                            value={el}
                            id={`checkbox-${el}`}
                            name="nsaYearFilter"
                            onChange={(event) => handleNSAYearFilter(event, el)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`checkbox-${el}`}
                            // onClick={(event) => handleNSAYearFilter(event, el)}
                          >
                            {el}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className='col-md-3'>
                <div className="button-wrap">
                  <Button
                    className="bttn submit-bnt"
                    type="submit"
                    text="Search"
                    onClick={handleSearchBySelect}
                    disabled={searchDisable}
                  />
                </div>
              </div>
            </div>}
          </div>
        </div>



        {nsaResultView ? <>
          <Refresh
            onClickRefresh={refreshStatupList}
            className=""
          />
          <div className='entity-details-box'>
            <div className='entity-heading'>Entity Details</div>
            <div className='row p18'>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Recognition No"
                  value={certificateNumber}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Incorporation Date"
                  value={incorporationDate}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Incorporation No."
                  value={incorporationNumber}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Name of Entity"
                  value={nameOfEntity}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className='row mt-2 mb-2 mt-4 justify-content-end ml-0 mr-0 entity-row'>
            <div className='col-md-3'>
              <div onClick={handleOpenSelectDropdown}
                className={`download-container bttn dropdown-check dropdown-check-list ${openSelectDropdown ? 'show' : ""}`}
              >
                {select}    <img width="15px" src={downArrowBtnblack} className='showicon-black' />
                <img src={downArrowBtn} width="15px" className='showicon-white' />
                <ul>
                  <li >
                    <div className="form-check">
                      <input className="form-check-input" type="radio" value={'Winner'} id={`checkbox-${'Winner'}`} name="selectBy" onChange={(event) => handleSelectBy(event, 'Winner')}  />
                      <label className="form-check-label" htmlFor={`checkbox-${'Winner'}`} >
                        Winner
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" value={'Finalist'} id={`checkbox-${'Finalist'}`} name="selectBy" onChange={(event) => handleSelectBy(event, 'Finalist')} />
                      <label className="form-check-label" htmlFor={`checkbox-${'Finalist'}`} >
                        Finalist
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3'>
              <div onClick={handleOpenNSAYearDropdown}
                className={`download-container bttn dropdown-check dropdown-check-list ${openNSAYearDropdown ? 'show' : ""}`}
              >
                {nsaYear}    <img width="15px" src={downArrowBtnblack} className='showicon-black' />
                <img src={downArrowBtn} width="15px" className='showicon-white' />
                <ul>
                  {nsaYearArray?.map((el) => (<li key={el} >
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value={el}
                        id={`checkbox-${el}`}
                        name="nsaYear"
                        onChange={(event) => handleNSAYear(event, el)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${el}`}
                      >
                        {el}
                      </label>
                    </div>
                  </li>))}


                </ul>


              </div>
            </div>
            <div className='col-md-2 p-0 pding15'>
              <div className="button-wrap">
                <Button
                  className="bttn submit-bnt"
                  type="submit"
                  text="Save"
                  onClick={handleSubmit}
                  disabled={saveDisable}
                />
              </div>
            </div>
          </div>
        </> : <>
          <div className='row' style={{ marginTop: '15px' }}>

            <div className='col-sm-12 mt-3 w-100' style={{ paddingRight: '24px' }}>
              <Download
                fileName={'NSA Result Details'}
                onClickDownload={downloadNSAResultList}
                className="bttn-link"
              />
            </div>
          </div>
          <Table
            dataTable={data}
            columns={columns({
              handleEditClick: handleEditClick,
              clickOnAction,
              pageNo: pageNo,
              size: sizePerPage
            })}
            keyField='applicationId'
            onSortChange={onSortChange}
            totalSize={recordsTotal}
            rowStyle={rowStyle2}
            sizePerPage={sizePerPage}
            onPageChange={handleOnPageChange}
            onSizePerPageChange={handleOnSizePerPageChange}
            actionHandler={actionHandler}
          /></>}
      </div>
      <Modal isOpen={openDeletemodal} toggle={toggleDeleteModal} className="nsa-report">
                <ModalHeader toggle={toggleDeleteModal} className='nsa-modal-title'>
                  Delete NSA Record
                </ModalHeader>
                <ModalBody className="mt-3 mb-3">
                    <div className="row">
                        <div className="tags-select col-md-6 my-2">
                        <div className="d-flex justify-content-center align-items-center">
                            <input 
                                type="radio" 
                                id="custom" 
                                name="dateRange"
                                value="CUSTOM" 
                                className="nsa-tag-modal-edit" 
                                onChange={handleUpdateTag} 
                                />
                            <label className="nsa-tag-modal-label" htmlFor="custom">Custom</label>
                        </div>
                        </div>
                        <div className="tag-select col-md-6">
                        <div className="d-flex justify-content-center align-items-center">
                            <input 
                              type="radio" 
                              id="all" 
                              name="dateRange" 
                              value="ALL"
                              defaultChecked
                              className="nsa-tag-modal-edit"
                              onChange={handleUpdateTag}
                          />
                          <label className="nsa-tag-modal-label" htmlFor="all">All</label>
                        </div>
                        </div>
                    </div>

                    {/* {showCustomEditNSA && (
                      <div className='row nsa-edit-selectbox mt-3'>
                        <div className="col-md-6">
                          <label htmlFor="nsa-status">Select Status</label>
                          <Select
                            id="nsa-status"
                            value={statusNsaUpdate}
                            onChange={handleStatusNsaUpdate}
                            options={selectedStatusNSA}
                            placeholder="Choose Status"
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="nsa-year">Select Year</label>
                          <Select
                            id="nsa-year"
                            value={yearNsaUpdate}
                            onChange={handleYearNsaUpdate}
                            options={selectedYearNSA}
                            placeholder="Choose Year"
                          />
                        </div>
                      </div>
                    )} */}

                    {showCustomEditNSA && (
                      <div className='row nsa-edit-selectbox mt-4 mx-4'>
                        <div className="col-md-12">
                        <label htmlFor="nsa-tag">Select Tag</label>
                          <Select
                            id="nsa-tag"
                            name="nsa-tag"
                            onChange={handleDeleteNsaTagUpdate}
                            options={deleteTagOptions}
                            defaultValue={deleteTagOptions[0]}
                            placeholder="Tag"
                            className='NsaTagSelection'
                            styles={{
                              control: (base) => ({
                                ...base,
                                backgroundColor: '#F5F5F5',
                                color: 'white',
                                borderColor: '#ECECEC',
                                ':hover': {
                                  borderColor: '#F5F5F5',
                                },
                              }),
                            }}
                          />
                        </div>
                      </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <div className="button-container">
                        {/* <button className="download-container downloadReport-sui" onClick={handleUpdateSubmit}> */}
                        <button className="download-container nsa-delete-btn mb-3" disabled={(showCustomEditNSA && nsaUpdate.tag==='' && nsaDeleteAction!=='ALL')} onClick={openConfirmationModal}>
                            Delete
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            {/* Confirmation Modal */}
            <Modal isOpen={openConfirmation} toggle={closeConfirmationModal} className="confirmation-nsa-delete-modal">
                <ModalBody className="">
                    <div className="row">
                        <div className='confirmation-delete-icon col-md-12 mt-1 text-center'>
                        <img width="125px" src={deleteIconGif} className='showicon-black' />
                        </div>
                        <div className='confirmation-delete-message col-md-12  mb-2 text-center'>
                            <h4 className='mx-5'>Are you sure you want to delete this record?</h4>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="d-flex justify-content-center align-items-center col-md-6">
                            <input 
                              type="radio" 
                              id="delete-yes" 
                              name="deleteConfiramtion" 
                              value="yes" 
                              className="form-check-input nsa-tag-delete-confirmation"
                              onChange={handleConfirmation}
                          />
                          <label className="form-check-label nsa-tag-modal-label h5 my-2" htmlFor="delete-yes">Yes</label>
                        </div>
                        <div className="d-flex justify-content-center align-items-center col-md-6">
                            <input 
                              type="radio" 
                              id="delete-no" 
                              name="deleteConfiramtion" 
                              value="no" 
                              className="form-check-input nsa-tag-delete-confirmation"
                              onChange={handleConfirmation}
                          />
                          <label className="form-check-label nsa-tag-modal-label h5 my-2" htmlFor="delete-no">No</label>
                        </div>
                        </div>

                </ModalBody>
                {showDeleteConfirmation && (<ModalFooter>
                    <div className="button-container">
                        {/* <button className="download-container downloadReport-sui" onClick={handleUpdateSubmit}> */}
                        <button className="download-container nsa-delete-btn mb-3" onClick={handleDeleteNsaRecord}>
                            Ok
                        </button>
                    </div>
                </ModalFooter>)}
            </Modal>

            {/* History Modal */}
            <Modal isOpen={openHistory} toggle={closeHistoryModal} className="last-generated-report">
                <ModalHeader toggle={closeHistoryModal}>
                    Last Updated 
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className='last-generated'>
                            <ul>
                                <li><strong>Name : </strong> <p>{historyData['adminName']}</p></li>
                                <li><strong>Action : </strong> <p>{historyData['action']}</p></li>
                                <li><strong>Action Date : </strong> <p>{moment(historyData['actionDate']).format('DD/MM/YYYY')}</p></li>
                                {/* <li><strong>Type : </strong> <p>{historyData['updateType']}</p></li> */}
                                <li><strong>Type : </strong> <p>Static</p></li>
                            </ul>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className="button-container">
                        <button className="download-container downloadReport-Generated" onClick={(event) => closeHistoryModal(event)}>
                            Ok
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
    </div>
    
  )
}

const mapStateToProps = (state) => {
  return {
    // natureOfTheEntity: state.startupApplicationForm.natureOfTheEntity,
    // startupSectionList: state.startupSectionList.startupSelectionData,
    nsaReportDataState: state.nsaReportList.nasReportData,

  }
}

export default connect(mapStateToProps, { getNSAReportList, saveNsaResultData, doDownloadResultList, isLoading, updateNSAReportList, lastGeneratedReportHistory })(withRouter(NSAResult));
